module.exports = __webpack_public_path__ + "img/main_gjjys.85254aca.png";